import emojiConf from "./emoji";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { Grounds } from "@ifeng-fe/client_grounds";

// dayjs配置 Duration 插件
dayjs.extend(duration);

export const getQuery = (): Record<string, string> => {
    const ret: Record<string, string> = {},
        seg = window.location.search.substring(1).split("&"),
        len = seg.length;

    let s,
        i = 0;
    for (; i < len; i++) {
        if (!seg[i]) {
            continue;
        }
        s = seg[i].split("=");
        ret[s[0]] = s[1];
    }
    return ret;
};

// 节流
export function throttle(handler: any, wait: number) {
    let lastTime = 0;

    return () => {
        const nowTime = new Date().getTime();

        if (nowTime - lastTime > wait) {
            handler();
            lastTime = nowTime;
        }
    };
}

export const getBrComment = (text: string, ellipsis?: string) => {
    const reg = new RegExp(`((\n)|(\\\\n))+${ellipsis}$`, "g");

    return text.replace(reg, "<br />").replace(/(\n)+/g, "<br />");
};

// 格式化评论，替换表情
export const formatComment = (comment: string) => {
    const reg = /\[([^[\]]+)]/g;

    const text = comment.replace(reg, (match, p1) => {
        const emoji = emojiConf.find((item) => item.code === `[${p1}]`);

        if (emoji) {
            return `<img style="width:0.5rem;vertical-align:middle;" src="${`https://x0.ifengimg.com/fe/circle/emoji/${p1}.png`}" alt="${p1}" />`;
        }

        return match;
    });

    return text;
};

// 评论的日期时间格式化
// 用户传入时间例如2021-07-10 13:00:33
// 如果传入时间距离当前时间超过24小时则展示XX天前
// 如果传入时间距离当前时间超过1小时但不超过24小时，则展示XX小时前
// 如果传入时间距离当前时间不超过1小时，则展示XX分前
// 如果传入时间距离当前时间不超过1分钟，则展示刚刚
export const formatTime = (date: string) => {
    const now = new Date().getTime();
    const old = new Date(date).getTime();
    if (now - old > 72 * 60 * 60 * 1000) {
        return "";
    } else {
        const dateFormat = date.replace(/\//g, "-");
        if (!dateFormat) return date;
        const currentTime = dayjs();
        const targetTime = dayjs(dateFormat);
        const ms: Record<string, any> = targetTime.isAfter(currentTime) ? dayjs.duration(targetTime.diff(currentTime)) : dayjs.duration(currentTime.diff(targetTime));
        const days = Math.floor(ms.asDays() as number);
        const hours = Math.floor(ms.asHours() as number);
        const minutes = Math.floor(ms.asMinutes() as number);

        if (hours > 72) {
            return "";
        } else if (hours >= 24) {
            return `${days}天前`;
        } else if (hours > 0) {
            return `${hours}小时前`;
        } else if (minutes > 0) {
            return `${minutes}分前`;
        } else {
            return "刚刚";
        }
    }
};

// 格式化人数
export const formatPeopleCount = (count: string | number) => {
    const countNew = Number(count);
    if (countNew > 99999999) {
        return `${(countNew / 100000000).toFixed(1)}亿`;
    } else if (countNew > 9999) {
        return Number((countNew / 10000).toFixed(1)) === 10000 ? "9999.9万" : `${(countNew / 10000).toFixed(1)}万`;
    } else {
        return countNew;
    }
};

export const pageHandler = ({ id }: { id: string }) => {
    try {
        if (window.grounds) {
            Grounds.setShareVisibility(0);
            // Grounds.pageStat({
            //     id,
            // });
            // 判断是否是安卓系统，是的话去掉弹性滚动
            if (
                Grounds.getDeviceInfo()
                    .getOs()
                    .match(/android/)
            ) {
                console.log("android");
            } else {
                Grounds.disableBounceEffect("close");
            }
        }
    } catch (error) {
        console.error(error);
    }
};

type dispatchParams = {
    type: string;
    url: string;
    ref?: string;
    commentId?: string;
};
// 防抖
export const debounce = (func: any, wait: number, imme?: boolean) => {
    let timer: NodeJS.Timeout | undefined;
    return function () {
        if (imme && !timer) {
            func();
        }
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => func(), wait);
    };
};

export const gotoNewPage = ({ type, url, ref }: dispatchParams) => {
    if (window.grounds) {
        const urlNew = url ? (url.indexOf("?") > -1 ? `${url}&isFull=0` : `${url}?isFull=0`) : "";
        return debounce(() => {
            if (url) {
                Grounds.dispatch({
                    link: { type, url: urlNew },
                    pageLogParams: { ref },
                });
            }
        }, 300);
    } else {
        return debounce(() => {
            console.log(url)
            if (url) {
                window.open(url);
            }
        }, 300);
    }

};

export const goNative = ({ type, url, ref }: dispatchParams) => {
    return debounce(() => {
        if (url) {
            Grounds.dispatch({
                link: { type, url },
                pageLogParams: { ref },
            });
        }
    }, 300);
};

type redirectParams = {
    commentsUrl: string;
    title: string;
    shareUrl?: string;
    thumbnail?: string;
    documentId?: string;
    options?: any;
};
export const redirect2Comments = ({ commentsUrl, title, shareUrl, thumbnail, documentId, options }: redirectParams) => {
    return debounce(() => {
        if (commentsUrl) {
            Grounds.redirect2Comments(commentsUrl, title, shareUrl, thumbnail, documentId, options);
        }
    }, 300);
};

export const dispatchByLink = ({ type, url, commentId, ref }: dispatchParams) => {
    return debounce(() => {
        if (url) {
            const [mainVeision, smallVersion] = Grounds.getDeviceInfo().getGv().split(".");
            if (mainVeision >= 7 && smallVersion >= 55 && commentId) {
                Grounds.dispatchByLink({
                    link: {
                        type,
                        url,
                        ext: {
                            showComment: true,
                            jumpComment: commentId,
                        },
                    },
                    pageLogParams: {
                        ref,
                    },
                });
            } else {
                Grounds.dispatch({
                    link: { type, url },
                    pageLogParams: { ref },
                });
            }
        }
    }, 300);
};

export const jumpPageUrl = () => {
    const liveUrl = location.href.split("?")?.[0] || "";
    const urlSplit = liveUrl.split("/") || [];

    urlSplit.pop();
    const hostUrl = urlSplit.join("/");
    return hostUrl;
};

export const isNative = () => {
    return window.grounds;
};

export const getClient = () => {
    const ua = window.navigator.userAgent;
    let clientType;

    if (isNative()) {
        clientType = 'native';
    } else if (/MicroMessenger/i.test(ua)) {
        clientType = 'weixin';
    } else if (/WeiBo/i.test(ua)) {
        // 微博客户端
        clientType = 'weibo';
    }
    return clientType;
};
